/* tslint:disable */
/* eslint-disable */
/**
 * Ampli - A strong typed wrapper for your Analytics
 *
 * This file is generated by Amplitude.
 * To update run 'ampli pull kraken-web-ts'
 *
 * Required dependencies: @amplitude/analytics-browser@^1.3.0
 * Tracking Plan Version: 35
 * Build: 1.0.0
 * Runtime: browser:typescript-ampli-v2
 *
 * [View Tracking Plan](https://data.amplitude.com/homebot/Homebot%20Tracking%20Plan/events/main/latest)
 *
 * [Full Setup Instructions](https://data.amplitude.com/homebot/Homebot%20Tracking%20Plan/implementation/kraken-web-ts)
 */

import * as amplitude from '@amplitude/analytics-browser';

export type Environment = 'production' | 'development';

export const ApiKey: Record<Environment, string> = {
  production: '2cf0a9667eb806e96e2ed57b99dc3fb4',
  development: '46195d0a54e086957165730802316c5b'
};

/**
 * Default Amplitude configuration options. Contains tracking plan information.
 */
export const DefaultConfiguration: BrowserOptions = {
  plan: {
    version: '35',
    branch: 'main',
    source: 'kraken-web-ts',
    versionId: 'a7f02ac9-aebd-48bf-8cb2-690e2a88d2fe'
  },
  ...{
    ingestionMetadata: {
      sourceName: 'browser-typescript-ampli',
      sourceVersion: '2.0.0'
    }
  }
};

export interface LoadOptionsBase { disabled?: boolean }

export type LoadOptionsWithEnvironment = LoadOptionsBase & { environment: Environment; client?: { configuration?: BrowserOptions; }; };
export type LoadOptionsWithApiKey = LoadOptionsBase & { client: { apiKey: string; configuration?: BrowserOptions; } };
export type LoadOptionsWithClientInstance = LoadOptionsBase & { client: { instance: BrowserClient; } };

export type LoadOptions = LoadOptionsWithEnvironment | LoadOptionsWithApiKey | LoadOptionsWithClientInstance;

export interface IdentifyProperties {
  /**
   * uuid assigned to client
   *
   * | Rule | Value |
   * |---|---|
   * | Regex | [0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12} |
   */
  client_id?: string;
  /**
   * The number of clients associated with the customer profile
   *
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   * | Min Value | 0 |
   */
  clients_count?: number;
  /**
   * uuid of the corperation attached to a customer_profile
   *
   * | Rule | Value |
   * |---|---|
   * | Regex | [0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12} |
   */
  corp_id?: string;
  /**
   * uuid of attached customer in customer_properties
   *
   * | Rule | Value |
   * |---|---|
   * | Regex | [0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12} |
   */
  customer_id?: string;
  /**
   * email address on user JWT
   */
  email_address: string;
  /**
   * The domain portion (following @) of the email address associated with the users account
   *
   * | Rule | Value |
   * |---|---|
   * | Regex | [^.]+\..+ |
   */
  email_domain?: string;
  /**
   * optional portion of email between + and @
   *
   * | Rule | Value |
   * |---|---|
   * | Max Length | 256 |
   */
  email_tag?: string;
  environment: string;
  /**
   * more detail on type of user interest/scope
   *
   * | Rule | Value |
   * |---|---|
   * | Unique Items | true |
   * | Item Type | string |
   */
  user_scope?: string[];
  /**
   * type of account via JWT auth
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | client, customer, homebotter, unauthed |
   */
  user_type: "client" | "customer" | "homebotter" | "unauthed";
}

export interface AvmAlertViewedProperties {
  /**
   * What type of AVM alert is a client exposed to
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | avm_alert_variance, avm_alert_low_confidence, avm_alert_non_disclosure, avm_alert_in_demand |
   */
  avm_alert_type:
    | "avm_alert_variance"
    | "avm_alert_low_confidence"
    | "avm_alert_non_disclosure"
    | "avm_alert_in_demand";
}

export interface AvmFeedbackProperties {
  /**
   * Describes how the client engages to their AVM alert in Homebot
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | avm_thumbs_up, avm_thumbs_down, avm_learn_more, avm_dismissed, avm_tuned |
   */
  avm_alert_response: "avm_thumbs_up" | "avm_thumbs_down" | "avm_learn_more" | "avm_dismissed" | "avm_tuned";
}

export interface ClientCustomizedProperties {
  /**
   * Ways clients can customize their Homebot
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | confirmed_loan, updated_loan, added_loan, updated_loan_balance, updated_budget, updated_price_point, updated_buying_timeline |
   */
  customization_type:
    | "confirmed_loan"
    | "updated_loan"
    | "added_loan"
    | "updated_loan_balance"
    | "updated_budget"
    | "updated_price_point"
    | "updated_buying_timeline";
}

export interface ClientRequestedInfoProperties {
  /**
   * The type of request the client sent our customer
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | cma, tca, showing, prequal, instant_offer, should_i_sell, refi, market_temp |
   */
  request_type: "cma" | "tca" | "showing" | "prequal" | "instant_offer" | "should_i_sell" | "refi" | "market_temp";
}

export interface MapModifiedProperties {
  /**
   * The type of map modification the user did
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | map_panned, zoomed_out, zoomed_in |
   */
  search_map_adjustment: "map_panned" | "zoomed_out" | "zoomed_in";
}

export interface ModuleViewedProperties {
  /**
   * Describes the module content
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | avm, refi, purchase_power, cashout, airbnb, reverse_mortgage, pmi, net_worth, win, home_insurance, principal_interest, pay_extra_principal |
   */
  module_name:
    | "avm"
    | "refi"
    | "purchase_power"
    | "cashout"
    | "airbnb"
    | "reverse_mortgage"
    | "pmi"
    | "net_worth"
    | "win"
    | "home_insurance"
    | "principal_interest"
    | "pay_extra_principal";
  /**
   * The descending order in which the module was displayed
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   * | Min Value | 1 |
   * | Max Value | 20 |
   */
  module_position?: number;
}

export interface PageViewedProperties {
  /**
   * Pattern of the URL of the page
   */
  page_location: string;
  /**
   * Actual URL of the page including IDs
   */
  page_path?: string;
  /**
   * Name of the page that describes the content
   */
  page_title?: string;
}

export interface QuestionAskedProperties {
  /**
   * When a client DMs their LO/REA about a Homebot topic
   */
  direct_message_topic: string;
}

export interface SearchModifiedProperties {
  /**
   * Describes parameters the client filtered their search by
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | price_max, price_min, bedroom_min, bathroom_min, home_type, sqft_min, sqft_max, construction_year_min, construction_year_max |
   */
  search_filter_added:
    | "price_max"
    | "price_min"
    | "bedroom_min"
    | "bathroom_min"
    | "home_type"
    | "sqft_min"
    | "sqft_max"
    | "construction_year_min"
    | "construction_year_max";
}

export interface SearchSortProperties {
  /**
   * What order the client sorted their search results by
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | sort_price_low, sort_price_high, sort_sqft_smallest, sort_sqft_largest, sort_year_built_oldest, sort_year_built_newest |
   */
  search_sort_updated:
    | "sort_price_low"
    | "sort_price_high"
    | "sort_sqft_smallest"
    | "sort_sqft_largest"
    | "sort_year_built_oldest"
    | "sort_year_built_newest";
}

export interface ValueTunedProperties {
  /**
   * Describes how a client adjusts their AVM in Homebot
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | tune_increase, tune_decrease |
   */
  tuned_value_direction: "tune_increase" | "tune_decrease";
}

export interface WinClickedProperties {
  /**
   * Client WIN CTA type
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | should_you_sell, new_home, equity_smart_search, share, reserve, refi, home_insurance, pmi |
   */
  win_type:
    | "should_you_sell"
    | "new_home"
    | "equity_smart_search"
    | "share"
    | "reserve"
    | "refi"
    | "home_insurance"
    | "pmi";
}

export class Identify implements BaseEvent {
  event_type = 'Identify';

  constructor(
    public event_properties: IdentifyProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class AvmAlertViewed implements BaseEvent {
  event_type = 'AVM Alert Viewed';

  constructor(
    public event_properties: AvmAlertViewedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class AvmFeedback implements BaseEvent {
  event_type = 'AVM Feedback';

  constructor(
    public event_properties: AvmFeedbackProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class BudgetSaved implements BaseEvent {
  event_type = 'Budget Saved';
}

export class ClientCustomized implements BaseEvent {
  event_type = 'Client Customized';

  constructor(
    public event_properties: ClientCustomizedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ClientRequestedInfo implements BaseEvent {
  event_type = 'Client Requested Info';

  constructor(
    public event_properties: ClientRequestedInfoProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ExtraPrincipalAdjusted implements BaseEvent {
  event_type = 'Extra Principal Adjusted';
}

export class HomeAdded implements BaseEvent {
  event_type = 'Home Added';
}

export class HomeFavorited implements BaseEvent {
  event_type = 'Home Favorited';
}

export class InsightsViewed implements BaseEvent {
  event_type = 'Insights Viewed';
}

export class MapModified implements BaseEvent {
  event_type = 'Map Modified';

  constructor(
    public event_properties: MapModifiedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class MarketTempClicked implements BaseEvent {
  event_type = 'Market Temp Clicked';
}

export class ModuleViewed implements BaseEvent {
  event_type = 'Module Viewed';

  constructor(
    public event_properties: ModuleViewedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class NetWorthExplored implements BaseEvent {
  event_type = 'Net Worth Explored';
}

export class PageViewed implements BaseEvent {
  event_type = 'Page Viewed';

  constructor(
    public event_properties: PageViewedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PmiInfoRequested implements BaseEvent {
  event_type = 'PMI Info Requested';
}

export class PmiRemoved implements BaseEvent {
  event_type = 'PMI Removed';
}

export class QuestionAsked implements BaseEvent {
  event_type = 'Question Asked';

  constructor(
    public event_properties: QuestionAskedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class SearchCompleted implements BaseEvent {
  event_type = 'Search Completed';
}

export class SearchModified implements BaseEvent {
  event_type = 'Search Modified';

  constructor(
    public event_properties: SearchModifiedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class SearchSaved implements BaseEvent {
  event_type = 'Search Saved';
}

export class SearchSort implements BaseEvent {
  event_type = 'Search Sort';

  constructor(
    public event_properties: SearchSortProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ValueTuned implements BaseEvent {
  event_type = 'Value Tuned';

  constructor(
    public event_properties: ValueTunedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class WinClicked implements BaseEvent {
  event_type = 'WIN Clicked';

  constructor(
    public event_properties: WinClickedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class YearsInHomeAdjusted implements BaseEvent {
  event_type = 'Years In Home Adjusted';
}

export type PromiseResult<T> = { promise: Promise<T | void> };

const getVoidPromiseResult = () => ({ promise: Promise.resolve() });

// prettier-ignore
export class Ampli {
  private disabled: boolean = false;
  private amplitude?: BrowserClient;

  get client(): BrowserClient {
    this.isInitializedAndEnabled();
    return this.amplitude!;
  }

  get isLoaded(): boolean {
    return this.amplitude != null;
  }

  private isInitializedAndEnabled(): boolean {
    if (!this.amplitude) {
      console.error('ERROR: Ampli is not yet initialized. Have you called ampli.load() on app start?');
      return false;
    }
    return !this.disabled;
  }

  /**
   * Initialize the Ampli SDK. Call once when your application starts.
   *
   * @param options Configuration options to initialize the Ampli SDK with.
   */
  load(options: LoadOptions): PromiseResult<void> {
    this.disabled = options.disabled ?? false;

    if (this.amplitude) {
      console.warn('WARNING: Ampli is already intialized. Ampli.load() should be called once at application startup.');
      return getVoidPromiseResult();
    }

    let apiKey: string | null = null;
    if (options.client && 'apiKey' in options.client) {
      apiKey = options.client.apiKey;
    } else if ('environment' in options) {
      apiKey = ApiKey[options.environment];
    }

    if (options.client && 'instance' in options.client) {
      this.amplitude = options.client.instance;
    } else if (apiKey) {
      this.amplitude = amplitude.createInstance();
      // @ts-ignore
      return this.amplitude.init(apiKey, undefined, { ...DefaultConfiguration, ...options.client?.configuration });
    } else {
      console.error("ERROR: ampli.load() requires 'environment', 'client.apiKey', or 'client.instance'");
    }

    return getVoidPromiseResult();
  }

  /**
   * Identify a user and set user properties.
   *
   * @param userId The user's id.
   * @param properties The user properties.
   * @param options Optional event options.
   */
  identify(
    userId: string | undefined,
    properties: IdentifyProperties,
    options?: EventOptions,
  ): PromiseResult<Result> {
    if (!this.isInitializedAndEnabled()) {
      return getVoidPromiseResult();
    }

    if (userId) {
      options = {...options,  user_id: userId};
    }

    const amplitudeIdentify = new amplitude.Identify();
    const eventProperties = properties;
    if (eventProperties != null) {
      for (const [key, value] of Object.entries(eventProperties)) {
        amplitudeIdentify.set(key, value);
      }
    }
    return this.amplitude!.identify(
      amplitudeIdentify,
      options,
    );
  }

  /**
   * Track event
   *
   * @param event The event to track.
   * @param options Optional event options.
   */
  track(event: Event, options?: EventOptions): PromiseResult<Result> {
    if (!this.isInitializedAndEnabled()) {
      return getVoidPromiseResult();
    }

    return this.amplitude!.track(event, undefined, options);
  }

  /**
   * AVM Alert Viewed
   *
   * [View in Tracking Plan](https://data.amplitude.com/homebot/Homebot%20Tracking%20Plan/events/main/latest/AVM%20Alert%20Viewed)
   *
   * Client was exposed to 1 of the 4 AVM alerts
   *
   * Owner: Leia Schultz
   *
   * @param properties The event's properties (e.g. avm_alert_type)
   * @param options Amplitude event options.
   */
  avmAlertViewed(
    properties: AvmAlertViewedProperties,
    options?: EventOptions,
  ) {
    return this.track(new AvmAlertViewed(properties), options);
  }

  /**
   * AVM Feedback
   *
   * [View in Tracking Plan](https://data.amplitude.com/homebot/Homebot%20Tracking%20Plan/events/main/latest/AVM%20Feedback)
   *
   * Client provided feedback by engaging with an AVM alert
   *
   * Owner: Leia Schultz
   *
   * @param properties The event's properties (e.g. avm_alert_response)
   * @param options Amplitude event options.
   */
  avmFeedback(
    properties: AvmFeedbackProperties,
    options?: EventOptions,
  ) {
    return this.track(new AvmFeedback(properties), options);
  }

  /**
   * Budget Saved
   *
   * [View in Tracking Plan](https://data.amplitude.com/homebot/Homebot%20Tracking%20Plan/events/main/latest/Budget%20Saved)
   *
   * Client added or edited their budget
   *
   * Owner: Leia Schultz
   *
   * @param options Amplitude event options.
   */
  budgetSaved(
    options?: EventOptions,
  ) {
    return this.track(new BudgetSaved(), options);
  }

  /**
   * Client Customized
   *
   * [View in Tracking Plan](https://data.amplitude.com/homebot/Homebot%20Tracking%20Plan/events/main/latest/Client%20Customized)
   *
   * The client updated or confirmed important fields that customized their experience
   *
   * Owner: Leia Schultz
   *
   * @param properties The event's properties (e.g. customization_type)
   * @param options Amplitude event options.
   */
  clientCustomized(
    properties: ClientCustomizedProperties,
    options?: EventOptions,
  ) {
    return this.track(new ClientCustomized(properties), options);
  }

  /**
   * Client Requested Info
   *
   * [View in Tracking Plan](https://data.amplitude.com/homebot/Homebot%20Tracking%20Plan/events/main/latest/Client%20Requested%20Info)
   *
   * The client asked for important information that the customer needs to respond to
   *
   * Owner: Carey Clark
   *
   * @param properties The event's properties (e.g. request_type)
   * @param options Amplitude event options.
   */
  clientRequestedInfo(
    properties: ClientRequestedInfoProperties,
    options?: EventOptions,
  ) {
    return this.track(new ClientRequestedInfo(properties), options);
  }

  /**
   * Extra Principal Adjusted
   *
   * [View in Tracking Plan](https://data.amplitude.com/homebot/Homebot%20Tracking%20Plan/events/main/latest/Extra%20Principal%20Adjusted)
   *
   * Client adjusted extra monthly principal dropdown
   *
   * Owner: Leia Schultz
   *
   * @param options Amplitude event options.
   */
  extraPrincipalAdjusted(
    options?: EventOptions,
  ) {
    return this.track(new ExtraPrincipalAdjusted(), options);
  }

  /**
   * Home Added
   *
   * [View in Tracking Plan](https://data.amplitude.com/homebot/Homebot%20Tracking%20Plan/events/main/latest/Home%20Added)
   *
   * Client self added a new home via /home/new
   *
   * Owner: Leia Schultz
   *
   * @param options Amplitude event options.
   */
  homeAdded(
    options?: EventOptions,
  ) {
    return this.track(new HomeAdded(), options);
  }

  /**
   * Home Favorited
   *
   * [View in Tracking Plan](https://data.amplitude.com/homebot/Homebot%20Tracking%20Plan/events/main/latest/Home%20Favorited)
   *
   * Client favorited a listing
   *
   * Owner: Leia Schultz
   *
   * @param options Amplitude event options.
   */
  homeFavorited(
    options?: EventOptions,
  ) {
    return this.track(new HomeFavorited(), options);
  }

  /**
   * Insights Viewed
   *
   * [View in Tracking Plan](https://data.amplitude.com/homebot/Homebot%20Tracking%20Plan/events/main/latest/Insights%20Viewed)
   *
   * Client clicks on button to view personal financial insights on a listing in Homebot Home Search
   *
   * Owner: Leia Schultz
   *
   * @param options Amplitude event options.
   */
  insightsViewed(
    options?: EventOptions,
  ) {
    return this.track(new InsightsViewed(), options);
  }

  /**
   * Map Modified
   *
   * [View in Tracking Plan](https://data.amplitude.com/homebot/Homebot%20Tracking%20Plan/events/main/latest/Map%20Modified)
   *
   * Client using Home Search adjusted the map to view listings
   *
   * Owner: Leia Schultz
   *
   * @param properties The event's properties (e.g. search_map_adjustment)
   * @param options Amplitude event options.
   */
  mapModified(
    properties: MapModifiedProperties,
    options?: EventOptions,
  ) {
    return this.track(new MapModified(properties), options);
  }

  /**
   * Market Temp Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/homebot/Homebot%20Tracking%20Plan/events/main/latest/Market%20Temp%20Clicked)
   *
   * Client clicked CTA to access the Your Market panel
   *
   * Owner: Martha Bawn
   *
   * @param options Amplitude event options.
   */
  marketTempClicked(
    options?: EventOptions,
  ) {
    return this.track(new MarketTempClicked(), options);
  }

  /**
   * Module Viewed
   *
   * [View in Tracking Plan](https://data.amplitude.com/homebot/Homebot%20Tracking%20Plan/events/main/latest/Module%20Viewed)
   *
   * Client viewed a specific module
   *
   * Owner: Carey Clark
   *
   * @param properties The event's properties (e.g. module_name)
   * @param options Amplitude event options.
   */
  moduleViewed(
    properties: ModuleViewedProperties,
    options?: EventOptions,
  ) {
    return this.track(new ModuleViewed(properties), options);
  }

  /**
   * Net Worth Explored
   *
   * [View in Tracking Plan](https://data.amplitude.com/homebot/Homebot%20Tracking%20Plan/events/main/latest/Net%20Worth%20Explored)
   *
   * User clicked 'how is this calculated' below their net worth amount
   *
   * Owner: Leia Schultz
   *
   * @param options Amplitude event options.
   */
  netWorthExplored(
    options?: EventOptions,
  ) {
    return this.track(new NetWorthExplored(), options);
  }

  /**
   * Page Viewed
   *
   * [View in Tracking Plan](https://data.amplitude.com/homebot/Homebot%20Tracking%20Plan/events/main/latest/Page%20Viewed)
   *
   * Client viewed a specific page
   *
   * Owner: Martha Bawn
   *
   * @param properties The event's properties (e.g. page_location)
   * @param options Amplitude event options.
   */
  pageViewed(
    properties: PageViewedProperties,
    options?: EventOptions,
  ) {
    return this.track(new PageViewed(properties), options);
  }

  /**
   * PMI Info Requested
   *
   * [View in Tracking Plan](https://data.amplitude.com/homebot/Homebot%20Tracking%20Plan/events/main/latest/PMI%20Info%20Requested)
   *
   * In our PMI module, trigger is when the Tell me more button is clicked to expand the info panel.
   *
   * Owner: Leia Schultz
   *
   * @param options Amplitude event options.
   */
  pmiInfoRequested(
    options?: EventOptions,
  ) {
    return this.track(new PmiInfoRequested(), options);
  }

  /**
   * PMI Removed
   *
   * [View in Tracking Plan](https://data.amplitude.com/homebot/Homebot%20Tracking%20Plan/events/main/latest/PMI%20Removed)
   *
   * In our PMI module, trigger is when the "Ask About PMI Removal" button is clicked to DM the customer providing Homebot to their client.
   *
   * Owner: Leia Schultz
   *
   * @param options Amplitude event options.
   */
  pmiRemoved(
    options?: EventOptions,
  ) {
    return this.track(new PmiRemoved(), options);
  }

  /**
   * Question Asked
   *
   * [View in Tracking Plan](https://data.amplitude.com/homebot/Homebot%20Tracking%20Plan/events/main/latest/Question%20Asked)
   *
   * Client sends a direct message
   *
   * Owner: Leia Schultz
   *
   * @param properties The event's properties (e.g. direct_message_topic)
   * @param options Amplitude event options.
   */
  questionAsked(
    properties: QuestionAskedProperties,
    options?: EventOptions,
  ) {
    return this.track(new QuestionAsked(properties), options);
  }

  /**
   * Search Completed
   *
   * [View in Tracking Plan](https://data.amplitude.com/homebot/Homebot%20Tracking%20Plan/events/main/latest/Search%20Completed)
   *
   * Client input a city, county, or zip to search for home listings
   *
   * Owner: Leia Schultz
   *
   * @param options Amplitude event options.
   */
  searchCompleted(
    options?: EventOptions,
  ) {
    return this.track(new SearchCompleted(), options);
  }

  /**
   * Search Modified
   *
   * [View in Tracking Plan](https://data.amplitude.com/homebot/Homebot%20Tracking%20Plan/events/main/latest/Search%20Modified)
   *
   * Client modified home search results using search filters
   *
   * Owner: Carey Clark
   *
   * @param properties The event's properties (e.g. search_filter_added)
   * @param options Amplitude event options.
   */
  searchModified(
    properties: SearchModifiedProperties,
    options?: EventOptions,
  ) {
    return this.track(new SearchModified(properties), options);
  }

  /**
   * Search Saved
   *
   * [View in Tracking Plan](https://data.amplitude.com/homebot/Homebot%20Tracking%20Plan/events/main/latest/Search%20Saved)
   *
   * Client saved their search
   *
   * Owner: Leia Schultz
   *
   * @param options Amplitude event options.
   */
  searchSaved(
    options?: EventOptions,
  ) {
    return this.track(new SearchSaved(), options);
  }

  /**
   * Search Sort
   *
   * [View in Tracking Plan](https://data.amplitude.com/homebot/Homebot%20Tracking%20Plan/events/main/latest/Search%20Sort)
   *
   * Client sorted their listings search results
   *
   * Owner: Leia Schultz
   *
   * @param properties The event's properties (e.g. search_sort_updated)
   * @param options Amplitude event options.
   */
  searchSort(
    properties: SearchSortProperties,
    options?: EventOptions,
  ) {
    return this.track(new SearchSort(properties), options);
  }

  /**
   * Value Tuned
   *
   * [View in Tracking Plan](https://data.amplitude.com/homebot/Homebot%20Tracking%20Plan/events/main/latest/Value%20Tuned)
   *
   * Client tuned their value higher or lower
   *
   * Owner: Leia Schultz
   *
   * @param properties The event's properties (e.g. tuned_value_direction)
   * @param options Amplitude event options.
   */
  valueTuned(
    properties: ValueTunedProperties,
    options?: EventOptions,
  ) {
    return this.track(new ValueTuned(properties), options);
  }

  /**
   * WIN Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/homebot/Homebot%20Tracking%20Plan/events/main/latest/WIN%20Clicked)
   *
   * Client clicked on one of the WINs
   *
   * Owner: Leia Schultz
   *
   * @param properties The event's properties (e.g. win_type)
   * @param options Amplitude event options.
   */
  winClicked(
    properties: WinClickedProperties,
    options?: EventOptions,
  ) {
    return this.track(new WinClicked(properties), options);
  }

  /**
   * Years In Home Adjusted
   *
   * [View in Tracking Plan](https://data.amplitude.com/homebot/Homebot%20Tracking%20Plan/events/main/latest/Years%20In%20Home%20Adjusted)
   *
   * Client adjusted the years in home slider above refi options
   *
   * Owner: Leia Schultz
   *
   * @param options Amplitude event options.
   */
  yearsInHomeAdjusted(
    options?: EventOptions,
  ) {
    return this.track(new YearsInHomeAdjusted(), options);
  }
}

export const ampli = new Ampli();

// BASE TYPES
type BrowserOptions = amplitude.Types.BrowserOptions;

export type BrowserClient = amplitude.Types.BrowserClient;
export type BaseEvent = amplitude.Types.BaseEvent;
export type IdentifyEvent = amplitude.Types.IdentifyEvent;
export type GroupEvent = amplitude.Types.GroupIdentifyEvent;
export type Event = amplitude.Types.Event;
export type EventOptions = amplitude.Types.EventOptions;
export type Result = amplitude.Types.Result;
